<template>
    <div class="business">
    <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
    />

    <div>
        <div class="bulkUploadClass" v-if="uploadMethod =true">
            <div class="download-btn">
                <download-button @downloadTemplate="downloadTemplate" >
                </download-button>
            </div>
            <div class="margin-t-15px" :key="componentKey">
                <upload-file :sheetLoading="sheetLoading" :apiUrl="bulkUploadUrl" :params="uploadParams" @uploadTemplate="onUploadTemplate($event)" />
            </div>
        </div>
      
        <pop-up-message
      v-if="showErrorPopup"
      message=""
      popupType="Warning"
      :popupHeaderMessage="'UPLOAD FAILED!!!'">
      
        <template v-slot:bottomContent>
        <div class=" margintop-32">
          <div class="Rectangle margintop-32">
          <span class="Information-message">{{ logMessage }}</span>
        </div>
    </div>
      <div class="margintop-32 custom-container">
      <a :href="logSheetUrl"
        @click="downloadItem(logSheetUrl)"
      ><img src="@/assets/download.svg"  class="img" /> <span class="text">Error Log Sheet</span></a>
          </div>

          <div class="popup-btn-group margintop-32 marginright">

            <button class="btn-popup" type="button" @click="backfromlogpopup()">Back To IT Declaration</button>

          <!-- <button class="btn-popup" type="button" @click="uploadFile2($event)">Proceed</button>
                -->  </div>
        </template>
      </pop-up-message>

      <pop-up-message
        v-if="showSuccessMsg"
        :message="`Bulk_Upload_File.xls Successfully Uploaded.`"
        btnText="OK"
        @back="goToBack"
      ></pop-up-message>

        <pop-up-message
        v-if="showSuccessBulkUploadMsg"
        :message="`${responseMsg} Bulk_Upload_File.xls Successfully Uploaded.`"
        btnText="Back"
        @back="goToBack"
      ></pop-up-message>
      <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Back" type="secondary" @click="closePopup()"/>
              
              <btn  v-if="enableButton==true" text="Save" type="primary" @click ="savePlan()"/>
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
      <div class="not-found-user-modal" v-if="notFoundUser">
        <div class="not-found-user-modal-content">
        <data-table
        :columns="employeeTableColumns"
        :tableData="employeeData"
        :showinrow="true"
        :with-form="false"
        :showhistory="false"
        :showdelete="false"
        :showedit="false">
        </data-table>
        <div class="btn-right-style">
          <btn text="Back" type="primary" @click ="backNotFoundUSer()"/>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions,mapGetters,mapState } from 'vuex';
import { api_variables } from "@/apis/variables.js";
import DataTable from '../../../../../../components/DataTable.vue';
export default {
    name: "incomeTaxBulkPopup",
    props: {
  
        DataTable},
  data() {
    return {
      bulkUploadUrl: api_variables.IT_SERVICE_BULK_UPLOAD,
      showSuccessBulkUploadMsg:false,
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      enableButton: false,
      formData: new FormData(),
      employeeData: [],
      showErrorPopup:false,
      logSheetUrl: null,
      logMessage: null,
      componentKey: 0,
      sheetLoading: true,
      employeeTableColumns: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Status",
          key: "status"
        },
      ],
      notFoundUser: false
    };
  },
  computed: {
    ...mapState({
      payrollYear: state => state.payroll.runpayroll.payrollYear,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth
    }),
     ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),

    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    
    uploadParams() {
      let obj = {
        financial_year:this.payrollYear,
        month: this.payrollMonth.substring(0,3).toLowerCase()
      };
      return obj;
    }

  },

  mounted() {
    this.showSuccessMsg = false;
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.showSuccessMsg = false;
  },

  methods: {
    ...mapActions({
         act_download_template: "dashboard/payroll/incometax/downloadITTemplate",
         act_bulk_upload:"dashboard/payroll/incometax/it_bulk"
    }),

    async downloadTemplate() {
     try {
      let payload = {
        le_id: this.le_id,
        financial_year: this.payrollYear
      }
       let res = await this.act_download_template(payload);
     } catch (error) {
       this.toast = true;
       this.errmsg = error;
     }
   },
      closePopup() {
        this.$emit('hidepopup');
      },
      savePlan() {
        this.showSuccessMsg = true;
        //console.log("Stop data");
      },

      goToBack() {
        this.showSuccessBulkUploadMsg = false;
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/payroll/incometax`,
      });
      this.$emit('hidepopup');
     // window.location.reload();
    },
     /* function to get response after uploading in bulk */
    async onUploadTemplate(res) {
     //console.log("event",res)
       try {
        this.sheetLoading = true;
          if (res.data.status && res.data.statusCode==200) {
            this.sheetLoading = false;
            if(res.data.payload[0] == ""){
              this.enableButton = true;
              this.sheetLoading = true;
              this.responseMsg = res.message ? res.message : "";
              this.showSuccessBulkUploadMsg = true;
            }else{
              this.sheetLoading = true;
              this.showErrorPopup = true;
              this.logSheetUrl = res.data.payload[0];
              // this.logMessage = error.message;
            }
          this.employeeData = res.data.payload;
          // if(this.employeeData.length > 0) {
          //   this.notFoundUser = true;  
          // } else {
          //   this.enableButton = true;
          //   this.responseMsg = res.message ? res.message : "";
          //   this.showSuccessBulkUploadMsg = true;
          // }
          //this.notFoundUser = true;
          //this.enableButton = true;
            
          } else {
            this.toast = true;
            // this.errmsg = res.message;
          }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
        this.sheetLoading = false
      }
    },
    backNotFoundUSer() {
      this.notFoundUser = false;
      //this.enableButton = true;
      this.$emit('hidepopup');
    },

    backfromlogpopup(){
      this.showErrorPopup = false;
      this.componentKey += 1;
    },
  },
}
</script>

<style lang="scss" scoped>
.uploadDiv {
  width: 10%;
  margin-left: auto;
  text-align: center;
  justify-content: end;
  padding: 4px 0px 0px 0px;
  button {
    cursor: pointer;
    width: 60%;
    height: 70%;
    border-radius: 4px;
    color: #5d409f;
    border: 1px solid #5d409f;
  }
  img {
    height: 70%;
    margin-bottom: -6px;
  }
}
.lop-report {
  display: grid;
  grid-template-columns: 0.3fr 0.3fr 0.3fr auto;
  grid-gap: 10px;
}
.export-emp {
  float: right;
  margin-bottom: 1%;
  margin-top: 3%;
}
.export-section {
  margin-left: 12%;
  margin-top: 5px;
  align-items: center;
  display: flex;
}
.export-button {
  width: 85px;
  height: 20px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  margin-left: 5px;
  margin-right: 10px;
}
.sorttext {
  // width: 10%;
  text-align: center;
  line-height: 30px;
  color: #726f75;
  padding: 0px 0px 0px 10px;
}
.sorticons {
  width: 13%;
  padding: 8px 0px 5px 10px;
  span {
    padding-top: 10px;
    padding-left: 10px;
    border-left: 2px solid #34c0be;
  }
}
.cardClass {
  margin-bottom: 2%;
}
.download-btn {
  margin-top: 2%;
}
.upload {
  display: flex;
  width: 30%;
  margin-top: 2%;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(
      to right,
      lightgray 10px,
      rgba(255, 255, 255, 0) 0%
    ),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%);
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 20px 1px, 1px 20px;
  height: 140px;
}
.upload-button {
  display: flex;
  align-items: center;
  label {
    cursor: pointer;
    border: 1px solid #5d409f;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 15px;
    color: #5d409f;
  }
  #upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
  img {
    height: 19px;
    width: 19px;
    margin-right: 8px;
  }
}
.details {
  color: #979797;
  font-size: 11px;
  b {
    color: #535353;
  }
}

.not-found-user-modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(10px); 
}

.not-found-user-modal-content {
  max-height: 500px;
  overflow-y: scroll;
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  border-radius: 12px;
  //opacity: 0;
  padding: 30px 30px 30px 30px;
  -webkit-animation-name: showPopup-data-v-e576876a;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
}

.btn-right-style {
  margin: 12px 0px;
}

.custom-container {
  display: flex;
  font-size: 18px;
  gap: 10px;
}

.custom-container > a{
  display: flex;
  gap: 10px;
  align-items: center;
}
</style>